import {HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot,Resolve,RouterStateSnapshot,Routes} from '@angular/router';
import {JhiResolvePagingParams} from 'ng-jhipster';
import {Observable} from 'rxjs';
import {UserRouteAccessService} from 'src/app/core';
import {ScopeMySuffix} from 'src/app/shared/model/scope-my-suffix.model';
import {ScopeMyCertificatesComponent,ScopeMyDeclarationsComponent,ScopeMyStorageCertificatesComponent} from '.';
import {ScopeMySuffixDeletePopupComponent} from './scope-my-suffix-delete-dialog.component';
import {ScopeMySuffixDetailComponent} from './scope-my-suffix-detail.component';
import {ScopeMySuffixUpdateComponent} from './scope-my-suffix-update.component';
import {ScopeMySuffixComponent} from './scope-my-suffix.component';
import {ScopeMySuffixService} from './scope-my-suffix.service';

@Injectable({ providedIn: 'root' })
export class ScopeMySuffixResolve implements Resolve<any> {
    constructor(private service: ScopeMySuffixService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {
            if (state.url.includes('view')) {
                return this.service.findForViewScope(id).map((scope: HttpResponse<ScopeMySuffix>) => scope);
            }
            return this.service.find(id).map((scope: HttpResponse<ScopeMySuffix>) => scope.body);
        }
        return Observable.of(new ScopeMySuffix());
    }
}

export const scopeRoute: Routes = [
    {
        path: '',
        component: ScopeMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/view',
        component: ScopeMySuffixDetailComponent,
        resolve: {
            scope: ScopeMySuffixResolve,
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/ots/view',
        component: ScopeMySuffixDetailComponent,
        resolve: {
            scope: ScopeMySuffixResolve,
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },

    {
        path: 'open-policy-scope-my-suffix/:id/view',
        component: ScopeMySuffixDetailComponent,
        resolve: {
            scope: ScopeMySuffixResolve,
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: ['UNDERWRITER', 'UNDERWRITER_STAFF', 'BROKER',
            'BROKER_STAFF','INSURER', 'INSURER_STAFF'],
            defaultSort: 'id,asc',
            pageTitle: 'OpenScopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new',
        component: ScopeMySuffixUpdateComponent,
        resolve: {
            scope: ScopeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:policyId',
        component: ScopeMySuffixUpdateComponent,
        resolve: {
            scope: ScopeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:policyId/:sType',
        component: ScopeMySuffixUpdateComponent,
        resolve: {
            scope: ScopeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:policyId/:sType/:changeTandCId',
        component: ScopeMySuffixUpdateComponent,
        resolve: {
            scope: ScopeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/edit',
        component: ScopeMySuffixUpdateComponent,
        resolve: {
            scope: ScopeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/edit/ots',
        component: ScopeMySuffixUpdateComponent,
        resolve: {
            scope: ScopeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'scope-my-declarations/:pid/:sid',
        component: ScopeMyDeclarationsComponent,
        resolve: {
            scope: ScopeMySuffixResolve,
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    { 
        path: 'scope-my-certificates/:pid/:sid',
        component: ScopeMyCertificatesComponent,
        resolve: {
            scope: ScopeMySuffixResolve,
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    { 
        path: 'scope-my-certificates/:pid/:sid/ots',
        component: ScopeMyCertificatesComponent,
        resolve: {
            scope: ScopeMySuffixResolve,
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'scope-my-storage-Insurance/:pid/:sid',
        component: ScopeMyStorageCertificatesComponent,
        resolve: {
            scope: ScopeMySuffixResolve,
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'location-my-storage-Insurance/:pid/:lid',
        component: ScopeMyStorageCertificatesComponent,
        resolve: {
            scope: ScopeMySuffixResolve,
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/ots/:policyId/:crId/:sType',
        component: ScopeMySuffixUpdateComponent,
        resolve: {
            scope: ScopeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:policyId/:sType/:changeTandCId/:crId',
        component: ScopeMySuffixUpdateComponent,
        resolve: {
            scope: ScopeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const scopePopupRoute: Routes = [
    {
        path: ':id/delete',
        component: ScopeMySuffixDeletePopupComponent,
        resolve: {
            scope: ScopeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];
